var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsos-popup-conversations-view"},[_c('organisation-selector'),(_vm.selectedOrganisation)?_c('div',{staticClass:"tsos-widget-incident-types-wrapper"},[_c('incident-type-selector')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }